import React, { Fragment } from 'react';

const BlogFourContent = [
    {
        id: 1,
        sector: 'Education',
        logo: 'cbbs.png',
        img: 'cbbs-2.jpg',
        title: 'Colombo Bartender & Barista School',
        desc: `Welcome to Sri Lanka's leading Bartender & Barista School. We pride ourselves on 6+ years of training & mentoring bartenders, baristas, and beyond.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://barbaristaschool.com/'
    },
    {
        id: 2,
        sector: 'Education',
        logo: 'cchss.png',
        img: 'cchss-3.jpg',
        title: 'Colombo Caregiver & Health Science School',
        desc: `Colombo Caregiver & Health Science School is Sri Lanka’s premier institution for caregiver, nursing, phlebotomy, and pharmacy technician training. Accredited by the TVEC and the only franchise of the American Caregiver Association (ACA) in the country, it exclusively offers the National Caregiver Certificate Course (NCCC), USA. Additionally, the school provides various healthcare courses in nursing, phlebotomy, and pharmacy technician training.`,
        dataAos: 'fade-right',
        dataDelay: '100',
        btnText: 'Explore More',
        url: 'https://www.ccsedu.lk/'
    },
    {
        id: 3,
        sector: 'Media',
        logo: 'jobdaddy.png',
        img: 'manpower.jpg',
        title: 'Jobdaddy.lk',
        desc: `Empowering job seekers to find their dream careers with boundless opportunities.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://jobdaddy.lk/'
    },

    {
        id: 7,
        sector: 'Media',
        logo: 'Exo Marcom Logo.png',
        img: 'Aviha Web - Exo Marcom Banner.png',
        title: 'Exo MarCom (Pvt) Ltd',
        desc: `Exo MarCom (Pvt) Ltd originated as the central marketing unit of the Aviha Group, and has built on its experiences of creating and managing multiple standout brands including the Colombo Bartender& Barista School, Colombo Caregiver & Health Science School, DocMart Pharmaceuticals and others. The company is conceived as a full service marketing agency focusing on doing the simple things in marcoms for clients - across verticals spanning Digital, Audio Visual and Content - enabling them to get their basic marketing infrastructure in place; enabling them to expand and grow on a great foundation.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: ''
    },

    {
        id: 4,
        sector: 'Healthcare',
        logo: 'docmart.jpg',
        img: 'docmart.jpg',
        title: 'Docmart Pharmaceuticals (Pvt) Ltd.',
        desc: `Your trusted partner for high-quality pharmaceuticals. Providing reliable healthcare solutions to communities, one product at a time.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://docmart.lk/'
    },

    {
        id: 5,
        sector: 'Education',
        logo: 'cec logo.png',
        img: 'CEC Web Banner for Aviha Web.png',
        title: 'Colombo English Club (Pvt) Ltd',
        desc: `Colombo English Club (CEC) is a modern learning platform designed to help individuals build confidence and fluency in English through practical, real-life communication. Focused on speaking, pronunciation, vocabulary, and professional usage, CEC creates a friendly and supportive environment where learners can practice English without fear. With interactive sessions, experienced trainers, and career-oriented content, Colombo English Club empowers students and working professionals to communicate clearly, confidently, and effectively in both local and international settings.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: ''
    },

    {
        id: 6,
        sector: 'Education',
        logo: 'ibrsc.png',
        img: 'Cover web IBRC.jpg',
        title: 'The International Bar-Barista Research & Support Centre  (IBRSC)',
        desc: `The International Bar-Barista Research & Support Centre  (IBRSC) is a global leader in beverage industry research, training, and consultancy, serving as a central hub for innovation in bartending and barista excellence. With a strong international network and a multidisciplinary team of experts, IBRC is committed to shaping the future of coffee and beverage service through cutting-edge research, comprehensive training, and industry collaboration. Established in 2025 and headquartered in Colombo-Sri Lanka, IBRSC works across continents to support professionals, entrepreneurs, and hospitality businesses in raising standards and creating meaningful customer experiences.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://ibrsc.com/'
    },


     {
        id: 8,
        sector: 'Investment',
        logo: 'paradisecorp.png',
        img: 'ParadiseCorp Web Banners.jpg',
        title: 'ParadiseCorp Global Investments (Pvt) Ltd ',
        desc: `The strategic investment and asset trading arm of Aviha Group, the company is focused on buy-and-sell operations and short-term, high-yield capital cycles. Focusing on investment and capital optimisation for the Aviha Group, the company enables:
               
                •	Liquidity enhancement through short-term, high-return ventures.
                •	Diversified income independent from operational subsidiaries 
                •	Strategic positioning to acquire assets or equity stakes relevant to the Group’s long-term goals. 
                •	Risk-balanced growth, using both tangible and financial market instruments.
`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://paradisecorpgi.com/'
    },
    
    {
        id: 9,
        sector: 'Healthcare',
        logo: 'lenama.png',
        img: 'Cover web lenama.jpg',
        title: 'Lenama Healthcare (Pvt) Ltd.',
        desc: `Founded with a vision to improve the healthcare system in Sri Lanka; Lenama Healthcare addresses the growing need for  high-quality, affordable essential medicines, pharmaceutical products, and medical supplies, whilst maintaining the highest ethical standards in business  practices.`,
        dataAos: 'fade-left',
        dataDelay: '50',
        btnText: 'Explore More',
        url: 'https://lenama.lk/'
    },
    




    

    
];

const CategorySector = ({ sector }) => {
    // Filter content based on the sector prop
    const filteredContent = BlogFourContent.filter(
        (item) => item.sector.toLowerCase() === sector.toLowerCase()
    );

    return (
        <Fragment>
            {filteredContent.map((val) => (
                <div key={val.id} className="blog-style-two style-four mb-lg-45 mb-75" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                    <div className="row gx-4 gx-xxl-5">
                        <div className="col-lg-6 mb-5">
                            <div className="blog-thumb text-center">
                                <img className="w-100" src={`/assets/img/brand-slider/${val.img}`} alt="img" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="blog-content-ccs">
                               
                                {/* <img style={{height:'100px', margin:'20px'}} src={`/assets/img/brand/${val.logo}`} alt="img" /> */}
                                <div className="d-flex align-items-center">
    <img 
        className="img-fluid me-3" 
        style={{ height: '100px' }} 
        src={`/assets/img/brand/${val.logo}`} 
        alt="img" 
    />
</div>

                                <h3>
                                    <a target='_blank' className="blog-title" href={`${val.url}`}>{val.title}</a>
                                </h3>
                                <p>{val.desc}</p>
                                <a className="more-btn" target='_blank' href={`${val.url}`}>{val.btnText}</a>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    );
};

export default CategorySector;
